<template>
    <div>
        <div class="loans">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img
                            class="part-one-title-img"
                            src="../assets/imgs/craft/part-1-title.png"
                            alt=""
                        />
                        <div class="part-text part-one-text">
                            为深入实施创新驱动发展战略，贯彻落实“成都人才新政12条”等，鼓励青年科技人才创新创业，为构建现代产业体系提供人才保障，开展“青年创客”创新创业资助。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img
                    src="../assets/imgs/loans/title1.png"
                    class="part-two-title-img"
                />
                <div class="part-text">
                    截至申报当年1月1日（不含）不满45周岁的青年创客。
                </div>
            </div>
            <div class="part-three">
                <img
                    src="../assets/imgs/loans/title2.png"
                    class="part-two-title-img"
                />
                <div
                    class="part-three-items part-text"
                    :style="item.boxHeight"
                    v-for="item in part3"
                    :key="item.id"
                >
                    {{ item.text }}
                </div>
                <div class="part-text" style="color: #3d5aa3">
                    注：同一项目获得国、省、市奖励，按最高资助额度给予支持。
                </div>
            </div>
            <div class="part-four">
                <img
                    src="../assets/imgs/loans/title3.png"
                    class="part-two-title-img"
                />
                <div class="part-four-main">
                    <img
                        src="../assets/imgs/entrepreneur/part4-label.png"
                        class="part-three-items-img"
                    />
                    <div
                        class="part-text"
                        v-for="(item, index) in part4"
                        :key="index"
                        style="margin-bottom: 0.2rem"
                    >
                        {{ item }}
                    </div>
                </div>
                <div
                    class="part-text"
                    style="color: #3d5aa3; margin-top: 0.22rem"
                >
                    注：每个企业允许1名符合条件的人员申报，已入选我市相关人才计划项目的人员不得以同一项目、同一企业重复申报。
                </div>
            </div>
            <div class="part-five">
                <img
                    src="../assets/imgs/loans/title4.png"
                    class="part-two-title-img"
                />
                <div class="part-text">
                    按照年度集中申报制度，登录“成都市科技项目申报系统”进行申报。
                </div>
            </div>
            <div class="contact">
                <img
                    class="top"
                    src="./../assets/imgs/label/contact4.png"
                    alt=""
                />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61887291">028-61887291</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市科学技术局成果转移转化与创新创业服务处
                    </div>
                </div>
            </div>
            <div class="part-six">
                <img
                    src="../assets/imgs/entrepreneur/code.png"
                    style="
                        width: 1.94rem;
                        height: 1.94rem;
                        margin-right: 0.25rem;
                    "
                />
                <img
                    src="../assets/imgs/entrepreneur/code-text.png"
                    style="width: 3.74rem; height: 1.5rem"
                    alt=""
                />
            </div>
            <!-- <div class="bottom-info">责任单位：成都市科学技术局成果转移转化与创新创业服务处</div>
      <div class="bottom-info" style="margin-top: 0.15rem">
        咨询电话：
        <a
                href="tel:028-61887291"
                >028-61887291</a
            >
      </div> -->
            <!-- <bottom
                phone="028-61887291"
                unit="成都市科学技术局成果转移转化与创新创业服务处"
            ></bottom> -->
        </div>
        <call
            phone="028-61887291"
            site="https://kjxm.cdst.chengdu.gov.cn/index.html"
        ></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";
export default {
    name: "craft",
    data() {
        return {
            part3: [
                {
                    id: 1,
                    boxHeight: "",
                    text: "（一）获国家部委（含直属事业单位）主办（承办）大赛一等奖（金奖）：给予一次性20万元经费资助。",
                },
                {
                    id: 1,
                    boxHeight: "",
                    text: "（二）获国家部委（含直属事业单位）主办（承办）大赛二、三等奖（银、铜奖），以及四川省、成都市科技部门主办（承办）的大赛一等奖，给予一次性15万元经费资助。",
                },
                {
                    id: 1,
                    boxHeight: "",
                    text: "（三）获四川省、成都市科技部门主办（承办）的大赛二、三等奖（银、铜奖），给予一次性10万元经费资助。",
                },
            ],
            part4: [
                "1.近三年内获得由国家部委（含国家部委直属单位）主办的国内知名科技类创新创业大赛三等奖（铜奖）以上奖励，以及四川省、成都市科技部门主办的创新创业大赛三等奖以上奖励，申请人为获奖者或获奖团队核心成员，获奖项目属于我市重点产业方向领域；",
                "2.在成都创办具有独立法人资格的科技型企业，并实施获奖项目；",
                "3.所创办企业注册资本实际到位不低于20万元，申请人持股比例不低于30%，企业注册成立时间截止申报当年1月1日（不含）不超过3年；",
                "4.创办的企业依法经营，无不良记录，无相关知识产权纠纷。",
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.loans {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 7.3rem;
        width: 7.5rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/entrepreneur/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.35rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 1.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 1.12rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-three-items-img {
        position: absolute;
        width: 4.7rem;
        height: 0.67rem;
        left: 50%;
        transform: translateX(-50%);
        top: -0.32rem;
    }

    .part-two {
        margin: 0 auto;
        border: 0.00001px solid transparent;

        width: 6.85rem;
        padding-bottom: 0.35rem;
        margin-top: 0.22rem;
        background: #fff;
        border-radius: 10px;
        padding-left: 0.43rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        position: relative;
        padding-top: 1.5rem;
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.52rem 0.25rem 0.35rem 0.25rem;

        .part-three-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
            padding-bottom: 0.35rem;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        padding: 2.04rem 0.25rem 0.35rem 0.25rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-four-main {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 15px;
            position: relative;
            padding-left: 0.31rem;
            padding-right: 0.31rem;
            box-sizing: border-box;
            padding-top: 0.6rem;
            padding-bottom: 0.35rem;
        }
    }

    .part-five {
        width: 6.85rem;
        background: #ffffff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        padding: 1.5rem 0.35rem 0.35rem 0.35rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
    }

    .part-six {
        width: 6.85rem;
        background: #ffffff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.35rem;
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}
</style>
